import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    activityDatumId: Number,
    path: String
  }
}
